<template>
  <transition name="fade-in">
    <div class="dialog" :class="alertType" v-if="isShow">
      <div
          class="dialog-container"
          :class="[isContainerShow ? 'show' : '']"
          :style="alertType == 'bottom-modal' ? {} : {width: `${width}px`}"
      >
        <div class="content">
          <p v-if="showText" v-for="t in showText.split('\n')" v-html="t" :style="{ textAlign: alignText}"></p>
          <slot name="content"></slot>
        </div>
        <div class="active-buttons" v-if="!ignoreAction">
          <template v-if="alertType == 'bottom-modal'">
            <div class="button" v-if="!ignoreEnter" :class="disableHighlight ? 'cancel' : 'enter'" @click="tapEnter">{{enterBtnName}}</div>
            <div class="button cancel" v-if="!ignoreCancel" @click="tapCancel">{{cancelBtnName}}</div>
          </template>
          <template v-else>
            <div class="button cancel" v-if="!ignoreCancel" @click="tapCancel">{{cancelBtnName}}</div>
            <div class="button" v-if="!ignoreEnter" :class="disableHighlight ? 'cancel' : 'ta--text-primary enter'" @click="tapEnter">{{enterBtnName}}</div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
export default {
  name: "global-dialog",
  data() {
    return {
      timerArr: [],
      isShow: false,
      isFade: false,
      isPanelFade: true,
      isContainerShow: false,
    }
  },
  beforeDestroy() {
    this.timerArr.forEach(t => {
      clearTimeout(t)
    })
  },
  methods: {
    tapModal() {
      if(this.ignoreAction) {
        return
      }
      if(this.ignoreCancel) {
        return
      }
      if(this.banTapModal) {
        return
      }
      if(this.alertType != 'bottom-modal') {
        return
      }
      this.tapCancel()
    },
    showDialog() {
      this.isShow = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.isContainerShow =  true
        }, 100)
      })
    },
    hideDialog() {
      this.isContainerShow = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.isShow =  false
        }, 100)
      })
    },
    hasShow() {
      return this.isShow
    },
    hideDialogOnly() {
      this.isPanelFade = false
    },
    tapEnter(){
      // console.log(this.cancelType)
      switch(this.cancelType){
        case 'all':
          if(this.autoHide){
            this.hideDialog()
          }
          break
        case 'onlyDialog':
          if(this.autoHide){
            this.hideDialogOnly()
          }
          break
      }
      this.timerArr[2] = setTimeout(() => {
        this.$emit('enter')
      }, 300)
    },
    tapCancel(){
      this.hideDialog()
      this.timerArr[3] = setTimeout(() => {
        this.$emit('cancel')
      }, 300)
    }
  },
  props: {
    showText: {
      default: ''
    },
    width: {
      default: 250
    },
    panelTop: {
      default: 40
    },
    ignoreCancel: {
      default: false
    },
    ignoreEnter: {
      default: false
    },
    ignoreAction: {
      default: false
    },
    disableHighlight: {
      default: false
    },
    enterBtnName: {
      default: '确定'
    },
    cancelBtnName: {
      default: '取消'
    },
    cancelType: {
      default: 'all'
    },
    autoHide: {
      default: true
    },
    alignText: {
      default: 'center'
    },
    alertType: {
      default: 'normal' // normal or bottom-modal
    },
    banTapModal: {
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-in-enter-active,
.fade-in-leave-active {
  transition: all 0.3s linear;
  opacity: 1;
}
.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.dialog {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .5);
  z-index: 150000;
  justify-content: center;
  align-items: center;
  .dialog-container {
    border-radius: 10px;
    background-color: #fff;
    //position: fixed;
    //top: 40%;
    //left: 50%;
    //margin-left: -125px;
    z-index: 150100;
    transition: 300ms;
    max-height: 80%;
    overflow: auto;
    .content {
      font-size: 0.14rem;
      padding: 20px;
      padding-bottom: 25px;
      word-break: break-all;
      text-align: center;
    }
    .active-buttons {
      display: flex;
      border-top: 1px solid #dbdbdb;
      .button {
        padding: 10px 0;
        text-align: center;
        flex-grow: 1;
        border-right: 1px solid #dbdbdb;
        color: #2196f3;
        &.cancel {
          color: #666666!important;
        }
        &:last-child {
          border-right: 0;
        }
      }
    }
  }
  &.bottom-modal {
    .dialog-container {
      width: 100%;
      border-radius: 10px 10px 0 0;
      background-color: #fff;
      position: fixed;
      top: auto;
      left: 0;
      bottom: -50vh;
      margin-left: 0;
      padding-bottom: env(safe-area-inset-bottom);
      transition: 500ms;
      .active-buttons {
        flex-direction: column;
        border-top: 1px solid #dbdbdb;
        .button {
          border-right: 0;
          border-bottom: 1px solid #dbdbdb;
          padding: 16px 0;
        }
      }
      &.show {
        bottom: 0;
      }
    }
  }
}
</style>
